import { TrackedPropertyRelationship } from '../graphql.generated';

export const relationships: Record<TrackedPropertyRelationship, string> = {
    [TrackedPropertyRelationship.Homeowner]: 'Homeowner',
    [TrackedPropertyRelationship.Landlord]: 'Landlord',
    [TrackedPropertyRelationship.Tenant]: 'Tenant',
    [TrackedPropertyRelationship.InterestedInBuying]: 'Interested in buying',
    [TrackedPropertyRelationship.Interested]: 'Just curious'
};

/**
 * Returns true if it is a MyHome relationship
 * @param relationship - TrackedPropertyRelationship
 */
export const isMyHomeRelationship = (
    relationship?: TrackedPropertyRelationship | null
) => {
    if (!relationship) return false;

    return (
        relationship === TrackedPropertyRelationship.Homeowner ||
        relationship === TrackedPropertyRelationship.Landlord
    );
};

/**
 * Get the text of relationship, e.g. `HOMEOWNER` becomes `Homeowner`
 * @param relationship - TrackedPropertyRelationship
 */
export const mapRelationship = (relationship: TrackedPropertyRelationship) => {
    return relationships[relationship];
};

/**
 * Get the description of relationship, e.g. `HOMEOWNER` becomes `I'm the homeowner`
 * @param relationship - TrackedPropertyRelationship
 */
export const getRelationshipCopy = (
    relationship: TrackedPropertyRelationship
): string => {
    const relationshipCopy: Partial<
        Record<TrackedPropertyRelationship, string>
    > = {
        [TrackedPropertyRelationship.InterestedInBuying]:
            "I'm interested in buying",
        [TrackedPropertyRelationship.Interested]: "I'm just curious"
    };

    return (
        relationshipCopy[relationship] ||
        `I'm the ${relationships[relationship].toLowerCase()}`
    );
};

/**
 * Get the description of relationship for tracked property page, e.g. `INTERESTED` becomes `Tracking because I am curious`
 * @param relationship - TrackedPropertyRelationship
 */
export const getTrackedRelationshipCopy = (
    relationship: TrackedPropertyRelationship | null | undefined
) => {
    const NO_RELATIONSHIP_COPY = 'Add relationship to property';
    const relationshipCopy: Partial<
        Record<TrackedPropertyRelationship, string>
    > = {
        [TrackedPropertyRelationship.InterestedInBuying]:
            "I'm interested in buying",
        [TrackedPropertyRelationship.Interested]:
            'Tracking because I am curious'
    };

    if (!relationship) {
        return NO_RELATIONSHIP_COPY;
    }

    return relationshipCopy[relationship]
        ? relationshipCopy[relationship]
        : `I'm the ${relationships[relationship].toLowerCase()}`;
};
